<micro-select-combo #sel
              placeholder="TBB Carrier Type"
              valueField="id"
              [mode]="mode"
              [(id)]="tbbCarrierType"
              (idChange)="change($event)"
              [options]="options"

              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
